module.exports = __webpack_public_path__ + "img/RoomPreferencesOutlined.6660ebac.svg";